import { Action } from "redux";
import { OrganizationKeyName } from "../../../model/Organization";

export const APPROVE_USER_FAIL = "APPROVE_USER_FAIL";

export interface ApproveUserFailAction extends Action {
  type: typeof APPROVE_USER_FAIL;
  organization: OrganizationKeyName;
  userId: string | number;
}

export const approveUserFailAction = (
  organization: OrganizationKeyName,
  userId: string | number
): ApproveUserFailAction => ({
  type: APPROVE_USER_FAIL,
  organization,
  userId,
});
